module.exports = __webpack_public_path__ + "static/brands-cybertalks-logo-9d43c04ada2f46ac3789f9cec99f45dc.svg";